module.exports = __webpack_public_path__ + "katarzynahero.jpg?268a17769730bd76fdbd116a8581ef2a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artists/katarzynahero.jpg
// module id = 1074
// module chunks = 0